var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 50,
    viewBox: "0 0 67 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.1529 14.5543C-0.747744 21.3625 -0.747744 32.413 6.1529 39.2213C9.05409 42.0836 12.8935 43.8586 16.9718 44.253L16.9718 44.2531L16.9816 44.2539C18.5226 44.3828 19.8562 43.2723 20.0128 41.7786L20.0129 41.7786L20.0141 41.765C20.1447 40.2446 19.0192 38.9289 17.5052 38.7744L17.5003 38.7739C14.7018 38.5067 12.0683 37.2955 10.0866 35.3402C5.36148 30.6784 5.36148 23.0972 10.0866 18.4353L19.663 8.98718C24.3881 4.32535 32.0723 4.32535 36.7974 8.98718C41.5225 13.649 41.5225 21.2303 36.7974 25.8921L32.0092 30.6162C30.931 31.6799 30.931 33.4334 32.0092 34.4972C33.0874 35.5609 34.8647 35.5609 35.9429 34.4972L40.7311 29.7731C47.6317 22.9649 47.6318 11.9144 40.7311 5.10617C33.8305 -1.70206 22.63 -1.70206 15.7293 5.10617L6.1529 14.5543Z",
    fill: "#3E97FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2232 20.2222C20.3226 27.0305 20.3226 38.081 27.2232 44.8892C34.1239 51.6974 45.3244 51.6974 52.225 44.8892L61.8014 35.441C68.7024 28.6325 68.7012 17.5832 61.8221 10.7567L61.8206 10.7552C58.9192 7.89266 55.0785 6.11685 50.9786 5.74193L50.9727 5.74143C49.4486 5.614 48.0725 6.69003 47.9402 8.23038C47.8096 9.75071 48.9352 11.0664 50.4491 11.2209L50.454 11.2214C53.2525 11.4886 55.886 12.6999 57.8677 14.6551C62.5928 19.3169 62.5928 26.8982 57.8677 31.56L48.2913 41.0082C43.5662 45.67 35.882 45.67 31.1569 41.0082C26.4318 36.3463 26.4318 28.7651 31.1569 24.1033L35.9451 19.3792C37.0233 18.3154 37.0233 16.5619 35.9451 15.4982C34.8669 14.4344 33.0896 14.4344 32.0114 15.4982L27.2232 20.2222Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0126ff786fe3583025a81129f512ac7f.svg";
export { ForwardRef as ReactComponent };